import * as React from 'react';

import ResultsListDesktop from '@presenters/web/components/ClubTabs/MemberResultTableDesktop';
import ResultsListMobile from '@presenters/web/components/ClubTabs/MemberResultTableMobile';
import { MemberResultProps } from '@presenters/web/pages/Clubs/Members/utils';

const ResultsListRow: React.FC<MemberResultProps> = prop => {
  return (
    <>
      <ResultsListDesktop {...prop} />
      <ResultsListMobile {...prop} />
    </>
  );
};

export default ResultsListRow;
